// Helpers for <input type="datetime-local"> values (YYYY-MM-DDTHH:mm) built from
// LOCAL time parts (NOT toISOString, which is UTC) so the default + clamp reflect
// the user's wall-clock time (e.g. SA UTC+2).

const pad = (n: number): string => String(n).padStart(2, '0');

/** Current local time as a `datetime-local` value: `YYYY-MM-DDTHH:mm`. */
export const localNowValue = (d: Date = new Date()): string =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

/**
 * Clamp a `datetime-local` value so it never exceeds now (string compare is
 * chronological on this format). An empty/cleared value falls back to now so a
 * cleared input can never flow into `new Date(...).toISOString()` and throw.
 */
export const clampNotFuture = (v: string): string => {
  const now = localNowValue();
  if (!v) return now;
  return v > now ? now : v;
};
